import { render, staticRenderFns } from "./SnapshotAssignments.vue?vue&type=template&id=02fb35c5&"
import script from "./SnapshotAssignments.vue?vue&type=script&lang=js&"
export * from "./SnapshotAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports